<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>I Think You’re Wrong (But I’m Listening)</title>
<link href="../styles/9781400208425_template.css" rel="stylesheet" type="text/css"/>
<section epub:type="chapter" title="Part One: Start With You">
<p class="part_no" id="part1"><span class="right_1" epub:type="pagebreak" id="page_xvii" title="xvii"><a href="#/text/nav#rpart1">part one</a></span></p>
<p class="part_tit"><a href="#/text/nav#rpart1"><b>START WITH YOU</b></a><span class="right_1" epub:type="pagebreak" id="page_xviii" title="xviii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781400208425_Part_1.vue?02c33c64